import { Button, ColourStateSolid, FlexGap, StackHorizontal } from '@ukpostbox/frontend-framework';
import React, { useEffect, useState } from 'react';

type MailTypeConditionType = {
	name: string;
	defaultValue: any;
	changeCallback: (value: any) => void;
};

function MailTypeCondition(props: MailTypeConditionType) {
	const [mailType, setMailType] = useState<number>(props.defaultValue || -1);

	useEffect(() => {
		if (mailType !== props.defaultValue) {
			props.changeCallback(mailType);
		}
	}, [mailType]);

	useEffect(() => {
		if (props.defaultValue !== undefined && props.defaultValue !== mailType) {
			setMailType(props.defaultValue);
		}
	}, [props.defaultValue]);

	return (
		<StackHorizontal gap={FlexGap.Small}>
			<Button
				title='Any'
				squared
				fullWidth
				onClick={() => setMailType(0)}
				colour={mailType === 0 ? ColourStateSolid.Selected : ColourStateSolid.Secondary}
			/>
			<Button
				title='Letter'
				squared
				fullWidth
				onClick={() => setMailType(1)}
				colour={mailType === 1 ? ColourStateSolid.Selected : ColourStateSolid.Secondary}
			/>
			<Button
				title='Parcel'
				squared
				fullWidth
				onClick={() => setMailType(2)}
				colour={mailType === 2 ? ColourStateSolid.Selected : ColourStateSolid.Secondary}
			/>
		</StackHorizontal>
	);
}

export { MailTypeCondition };
